window.Theme = window.Theme || {};

Theme.Events = {
  trigger: function (event, event_name, event_detail) {
    event.preventDefault();

    document.dispatchEvent(new CustomEvent(event_name, {
      detail: event_detail
    }));
  }
};

Theme.URLParams = {
  set: function (key, value) {
    const url = new URL(window.location.href);
    url.searchParams.set(key, value);
    history.replaceState(null, '', url);
  },

  get: function (key) {
    const url = new URL(window.location.href);
    return url.searchParams.get(key);
  },

  delete: function (key) {
    const url = new URL(window.location.href);
    url.searchParams.delete(key);
    history.replaceState(null, '', url);
  },

  has: function (key) {
    const url = new URL(window.location.href);
    return url.searchParams.has(key);
  }
};

Theme.Helpers = {
  toggle_attribute: function (element, attribute) {
    if (element.hasAttribute(attribute)) {
      element.removeAttribute(attribute);
    } else {
      element.setAttribute(attribute, true);
    }
  },

  prefetch: function (url) {
    if (document.querySelector(`link[href="${url}"]`)) {
      return;
    }

    const link = document.createElement("link");

    link.rel = "prefetch";
    link.href = url;

    document.head.appendChild(link);
  },

  debounce: function (fn, delay) {
    let timeout;

    return function() {
      const context = this;
      const args = arguments;

      clearTimeout(timeout);

      timeout = setTimeout(() => {
        fn.apply(context, args);
      }, delay);
    };
  },

  scroll_to: function (id, offset = 80) {
    const target = document.getElementById(id);

    if (!target) {
      return;
    }

    const position = target.offsetTop - offset;

    window.scrollTo({
      top: position,
      behavior: "smooth"
    });
  }
};

(function open_external_links_in_new_tab() {
  const links = document.querySelectorAll('a[href^="http"]:not([href^="' + window.location.origin + '"])');

  links.forEach(function(link) {
    link.setAttribute('target', '_blank');
  });
})();